import { useEffect, useState } from "react";
import * as MUI from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";

import { useAppThemeContext } from "../../../../context/ThemeContext";
import { useAuth } from "../../../../hooks/auth";

import LogoPA from "../../../../assets/logoPA.png";
import LogoPABranco from "../../../../assets/logoPABranco.png";
import Pmpe from "../../../../assets/pmpe.svg";
import Pcpe from "../../../../assets/pcpe.svg";
import Bmpe from "../../../../assets/bmpe.svg";
import PolCien from "../../../../assets/PCIENPE.svg";

export default function Header() {
  const { user } = useAuth();

  const [iP, setIP] = useState("");

  useEffect(() => {
    const getIPData = async () => {
      const res = await axios.get("https://geolocation-db.com/json/");
      setIP(res.data.IPv4);
    };
    getIPData();
  }, []);

  const { toggleTheme, themeName } = useAppThemeContext();

  const theme = MUI.useTheme();

  return (
    <MUI.Stack
      flex={1}
      height="7.5rem"
      sx={{
        "@media print": {
          display: "none",
        },
      }}
    >
      <MUI.Stack
        height="5rem"
        bgcolor={theme.palette.primary.light}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        px={["0.5rem", "2rem", "2rem"]}
      >
        <MUI.Stack
          flexDirection="row"
          gap={1}
          alignItems="center"
          displayPrint="none"
        >
          <MUI.Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
              color: "#fff !important",
            }}
          >
            CONTRASTE
          </MUI.Typography>
          <MUI.Switch size="small" onChange={toggleTheme} />
        </MUI.Stack>

        <MUI.Stack display="flex" flexWrap="wrap" textAlign="right">
          {user !== null ? (
            <MUI.Typography
              variant="caption"
              sx={{
                color: "#fff !important",
              }}
            >
              Olá {user.nome_completo}, seu acesso foi registrado com o IP: {iP}
            </MUI.Typography>
          ) : (
            false
          )}
        </MUI.Stack>
      </MUI.Stack>

      <MUI.Stack height="0.3rem" flexDirection="row">
        <MUI.Stack flex={1} bgcolor="#ff0035" />
        <MUI.Stack flex={1} bgcolor="#ffcb02" />
        <MUI.Stack flex={1} bgcolor="#049934" />
      </MUI.Stack>

      <MUI.Stack
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
        px={[0, "2rem", "5rem"]}
        sx={{
          borderBottom: `0.2rem solid ${theme.palette.primary.light}`,
        }}
      >
        <MUI.Stack>
          <Link to="/pagina-inicial">
            <img
              width="auto"
              height="70"
              className="pa"
              src={themeName === "light" ? LogoPA : LogoPABranco}
              alt="Logo Polícia Ágil"
            />
          </Link>
        </MUI.Stack>

        <MUI.Stack flexDirection="row" gap={[0, 4]} displayPrint="none">
          <img width="50" height="50" src={Pmpe} alt="Logo Polícia Militar" />
          <img width="50" height="50" src={Pcpe} alt="Logo Polícia Civil" />
          <img
            width="50"
            height="50"
            src={PolCien}
            alt="Logo Polícia Científica"
          />
          <img width="50" height="50" src={Bmpe} alt="Logo Bombeiro Militar" />
        </MUI.Stack>
      </MUI.Stack>
    </MUI.Stack>
  );
}
